const zones = window.cartDrawer.zones
let currentTotalPrice = window.cartDrawer.totalPrice

const initNewPdpEvents = () => {
	document.addEventListener("click", e => {
		let end = false

		document.querySelectorAll(".mainPrdradio").forEach(el => {
			if (el.checked) end = true
		})
		// if (end) return
		if (e.target.id === "mainPrdcontformbtn") {
			const id = e.target.closest("#mainPrd").querySelector("#variant_selectPrd").value
			if (!id) return
			if (id === 0 || id === "0") return
			console.log(id)

			addItem(Number(id))
			openCart(e)
		}
	})
}

const renderUpsell = async () => {
	const firstItem = document.querySelector(".cart_drawer--item")
	const id = firstItem
		? firstItem.getAttribute("data-id")
		: window.cartDrawer.cart.item_count > 0
			? window.cartDrawer.cart.items[0].product_id
			: 7907606987011 + "&limit=6"
	const res = await fetch(
		`/recommendations/products?section_id=product-recommendations_cart&product_id=${id}`
	)
	const html = await res.text()
	const upsell = document.querySelector(".cartupselljs")
	if (upsell) upsell.innerHTML = html

	setTimeout(init, 500)
	// if (document.querySelector('.cart_upsell-grid[data-tab="upsell"] .cart_upsell-product') > 6) {
	//   document.querySelector('.cart_upsell-grid[data-tab="upsell"]').classList.remove('hidden')
	// }
}

const loadmoreCleanup = () => {
	const upsell = document.querySelector("[data-tab=upsell]")
	const upsell_prds = upsell.querySelectorAll(".cart_upsell-product")
	const upsellBtn = document.querySelector("[data-tab-loadmore=upsell]")
	const wishlist = document.querySelector("[data-tab=wishlist]")
	const wishlist_prds = wishlist.querySelectorAll(".cart_upsell-product")
	const wishlistBtn = document.querySelector("[data-tab-loadmore=wishlist]")
	const wishlistControl = document.querySelector("[data-tab-control=wishlist]")

	if (wishlistControl.classList.contains("selected")) {
		console.log(wishlist_prds)

		if (wishlist_prds.length < 5) {
			wishlistBtn.classList.add("hidden")
			wishlist.classList.remove("hidden")
			upsell.classList.add("hidden")
			upsellBtn.classList.add("hidden")
		} else {
			wishlistBtn.classList.remove("hidden")
			wishlist.classList.remove("hidden")
			upsell.classList.add("hidden")
			upsellBtn.classList.add("hidden")
		}
	} else {
		if (upsell_prds.length < 5) {
			upsellBtn.classList.add("hidden")
			wishlist.classList.add("hidden")
			upsell.classList.remove("hidden")
			wishlistBtn.classList.add("hidden")
		} else {
			upsellBtn.classList.remove("hidden")
			wishlist.classList.add("hidden")
			upsell.classList.remove("hidden")
			wishlistBtn.classList.add("hidden")
		}
	}
}

const openWishlistDrawer = e => {
	if (e) stopEvents(e)
	openCart()
	const tab = document.querySelector('[data-tab-control="wishlist"]')
	if (tab) tab.click()
	setTimeout(() => {
		const cartContainer = document.querySelector(".cart_container")
		if (cartContainer) cartContainer.scrollBy(0, cartContainer.clientHeight)
	}, 500)
}

const addEventPdpButton = () => {
	document.addEventListener("click", e => {
		if (e.target.classList.contains("add-to-cart-primary-btn")) {
			const parent = e.target.closest("#cart-form_ppr")
			if (parent && parent.querySelector("#product-select_ppr")) stopEvents(e)
			updateQuickAddText()
			const id = parent.querySelector("#product-select_ppr").value
			if (!id) return
			addItem(Number(id))
		}
	})
}

const hideItems = () => {
	const empty = document.querySelector(".cart_drawer--empty")
	if (empty) empty.classList.remove("hidden")
	const items = document.querySelector(".cart_drawer--items")
	if (items) items.classList.add("hidden")
}

const showItems = () => {
	const empty = document.querySelector(".cart_drawer--empty")
	if (empty) empty.classList.add("hidden")
	const items = document.querySelector(".cart_drawer--items")
	if (items) items.classList.remove("hidden")
}

const hideShippingBar = () => {
	document.querySelector(".cart-shipping_bar").classList.add("hidden")
}
const showShippingBar = () => {
	document.querySelector(".cart-shipping_bar").classList.remove("hidden")
}

const hideShippingTotal = () => {
	const row = document.querySelector(".cart-drawer-total__row")
	if (row) row.classList.add("hidden")
}

const showShippingTotal = () => {
	const row = document.querySelector(".cart-drawer-total__row")
	if (row) row.classList.remove("hidden")
}

const updateQuickAddText = () => {
	setTimeout(() => {
		const flag = sessionStorage.getItem("cart_change_id") !== null
		const title = document.querySelector(".prdsctcst__wrapper-top h4")
		const btn = document.querySelector(".prdsctcst .prdsctcst__cont-form-btn")
		if (title)
			title.innerText = flag ? window.cartDrawer.t.edit.title : window.cartDrawer.t.add.title
		if (btn) btn.innerText = flag ? window.cartDrawer.t.edit.btn : window.cartDrawer.t.add.btn
		if (btn && btn.classList.contains("outofstock")) btn.innerText = window.cartDrawer.t.outofstock
	}, 100)
}

const checkIfCartIsEmpty = count => {
	if (count === 0) {
		hideItems()
		hideShippingBar()
	} else {
		showItems()
		showShippingBar()
	}
}

const showWishlistPopup = () => {
	const wishlistPopup = document.querySelector(".cart_drawer-popup")
	if (wishlistPopup) wishlistPopup.classList.remove("hidden_pupup")
}

const closeWishlistPupup = () => {
	const wishlistPopup = document.querySelector(".cart_drawer-popup")
	if (wishlistPopup) wishlistPopup.classList.add("hidden_pupup")
}

const updateShipping = async () => {
	const uabCountry = sessionStorage.getItem("countryCode")
	const currentZone = zones.filter(zone => zone.country_code === uabCountry)

	if (currentZone.length > 0) {
		updagteShippingText(currentZone[0])
	} else {
		const defaultZone = zones.filter(zone => zone.country_code === "US")
		console.log("updateShipping", defaultZone)

		if (defaultZone.length > 0) updagteShippingText(defaultZone[0])
	}
}

const updagteShippingText = zone => {
	const textEL = document.querySelector(".cart-shipping_bar__text")

	const limit = Number(zone.free_shipping_standart) / 100
	const limit2 = Number(zone.free_shipping_express) / 100
	const total =
		Number(document.querySelector("[data-total-price]").getAttribute("data-total-price")) / 100

	const amount_left = parseInt(limit - total).toFixed(2)
	const amount_left_express = parseInt(limit2 - total).toFixed(2)
	const text_parsed = window.cartDrawer.t.shipping.left.replace(
		"{{amount}}",
		`${window.cartDrawer.currencySymbol}${amount_left}`
	)
	const text_parsed_express = window.cartDrawer.t.shipping.leftExpress.replace(
		"{{amount}}",
		`${window.cartDrawer.currencySymbol}${amount_left_express}`
	)

	if (total < limit) {
		hideShippingTotal()
		if (textEL) textEL.innerHTML = text_parsed
	} else {
		showShippingTotal()
		if (textEL) {
			textEL.innerHTML = window.cartDrawer.shippingFreeHtml
		}
		if (total < limit2 && total > limit && total !== limit2 && total !== limit) {
			if (textEL) textEL.innerHTML = text_parsed_express
		}

		if (total >= limit) {
			document.querySelector(".cart_drawer--messege--shipping").classList.remove("hidden")
		} else {
			document.querySelector(".cart_drawer--messege--shipping").classList.add("hidden")
		}
	}

	let progress = total * 100 / limit
	if (total >= limit) {
		progress = total * 100 / limit2
		if (document.querySelector(".cart_drawer--messege--shipping [cart-banner-text]"))
			document.querySelector(".cart_drawer--messege--shipping [cart-banner-text]").innerHTML =
				window.cartDrawer.t.shipping.congratsExpress
		if (total <= limit2)
			document.querySelector(".cart_drawer--messege--shipping [cart-banner-text]").innerHTML =
				window.cartDrawer.t.shipping.congrats
	}

	const fill = document.querySelector(".cart-shipping_bar__progress_fill")
	if (fill) fill.style.width = `${progress}%`
}

const loadProducts = items => {
	const products = items.map((item, idx) => items[items.length - 1 - idx])
	document.querySelector('[data-tab="wishlist"]').innerHTML = ""
	products.forEach((product, i) => {
		let newHtml = `
      <div class="cart_upsell-product">
        <div class="cart_upsell-product__overlay">
          <div class="cart_upsell-remove-from-wishlist" data-variant-id="${product.variant
						.id}" data-customer-id="${window.customerId}" data-id="${product.id}">
            ${window.cartDrawer.binIcon}
          </div>
          <a href="/products/${product.handle}" onClick="location.href = '/products/${product.handle}'">
            <img src="${product.featuredImage}" alt="${product.title}">
          </a>
        </div>
        <div class="cart_upsell-product__wrap">
          <div class="cart_upsell-product__title">
            <a href="/products/${product.handle}">${product.title}</a>
          </div>
          <div class="cart_upsell-product__price">
            ${window.cartDrawer.currencySymbol}${parseInt(
			product.variant.price * window.Shopify.currency.rate
		)}
          </div>
        </div>
      </div>
    `

		document.querySelector('[data-tab="wishlist"]').innerHTML += newHtml
	})
}

const getWishlist = async () => {
	const url = "https://api.myshopapps.com/wishlist/V1/fetchWishlistData/" + window.customerId
	const options = {
		method: "POST",
		headers: {
			xtoken: window.wishlistApiKey,
			"Content-Type": "application/x-www-form-urlencoded",
			Accept: "application/json"
		},
		body: new URLSearchParams({ category_id: "" })
	}

	try {
		const response = await fetch(url, options)
		const data = await response.json()
		if (data.result === undefined) return

		if (data.result.length > 0) {
			loadProducts(data.result)
			if (document.querySelector(".empty_block[data-upsell-grid]"))
				document.querySelector(".empty_block[data-upsell-grid]").classList.remove("empty_block")
			if (data.result.length <= 4) {
				if (document.querySelector('.cart_upsell-grid--show [data-tab-loadmore="wishlist"]'))
					document
						.querySelector('.cart_upsell-grid--show [data-tab-loadmore="wishlist"]')
						.classList.add("hidden")
			} else {
				if (document.querySelector('.cart_upsell-grid--show [data-tab-loadmore="wishlist"]'))
					document.querySelector('[data-tab-loadmore="wishlist"]').classList.add("hidden")
				// document.querySelector('[data-tab-loadmore="wishlist"]').classList.add('hidden')
				if (document.querySelector(".cart_upsell-product"))
					document.querySelector(".cart_upsell-product").classList.add("hidden")
				if (document.querySelector(".cart_upsell-grid.empty_block"))
					document.querySelector(".cart_upsell-grid.empty_block").innerHTML =
						"Your wishlist is empty"
			}
		} else {
			document.querySelector('[data-upsell-grid][data-tab="wishlist"]').classList.add("empty_block")
			closeWishlistPupup()
		}

		initRemoveFromWishlist()

		loadmoreCleanup()
	} catch (error) {
		console.error(error)
	}
}

const getWishlistItems = async () => {
	const url = "https://api.myshopapps.com/wishlist/V1/fetchWishlistData/" + window.customerId
	const options = {
		method: "POST",
		headers: {
			xtoken: window.wishlistApiKey,
			"Content-Type": "application/x-www-form-urlencoded",
			Accept: "application/json"
		},
		body: new URLSearchParams({ category_id: "" })
	}

	try {
		const response = await fetch(url, options)
		const data = await response.json()
		if (data.result === undefined) return
		if (data.result.length > 0) {
			checkWishlistItems(data.result)
		}
	} catch (error) {
		console.error(error)
	}
}

const removeItemFromWishlist = async (id, variantId, customerId) => {
	const url = "https://api.myshopapps.com/wishlist/V1/removeWishlist/"
	const options = {
		method: "POST",
		headers: {
			xtoken: window.wishlistApiKey,
			"Content-Type": "application/x-www-form-urlencoded",
			Accept: "application/json"
		},
		body: new URLSearchParams({
			customer_id: window.customerId,
			product_id: Number(id),
			variant_id: Number(variantId),
			category_id: ""
		})
	}

	try {
		await fetch(url, options)
		getWishlist()
		wishListAlert(false)
		if (
			document.querySelectorAll("[data-tab=wishlist] .cart_upsell-product").length === 1 ||
			document.querySelectorAll("[data-tab=wishlist] .cart_upsell-product").length === 0
		)
			document.querySelector(".cart_upsell-grid[data-tab=wishlist]").innerHTML =
				'<span class="cart_upsell-empty">Your wishlist is empty.</span>'
	} catch (error) {
		showWishlistPopup()
	}
}

const wishListAlert = flag => {
	const alert = document.querySelector(".wishlist_alert")
	if (!alert) return
	flag
		? document.querySelector(".wishlist_alert").classList.add("show")
		: document.querySelector(".wishlist_alert").classList.remove("show")
	alert.classList.add("revealAlert")
	setTimeout(() => {
		alert.classList.remove("revealAlert")
	}, 3000)
}

const addItemToWishlist = async (id, variantId, customerId) => {
	const url = "https://api.myshopapps.com/wishlist/V1/addToWishlist/"

	const options = {
		method: "POST",
		headers: {
			xtoken: window.wishlistApiKey,
			"Content-Type": "application/x-www-form-urlencoded",
			Accept: "application/json"
		},
		body: new URLSearchParams({
			customer_id: customerId,
			product_id: Number(id),
			variant_id: Number(variantId),
			category_id: "",
			product_qty: ""
		})
	}

	try {
		await fetch(url, options).then(() => {
			getWishlist()
			wishListAlert(true)
		})
	} catch (error) {
		showWishlistPopup()
	}
}

const stopEvents = e => {
	e.preventDefault()
	e.stopPropagation()
	e.stopImmediatePropagation()
}

const updateCounter = count => {
	const counter = document.querySelector(".icon_cart .tcount")
	if (counter) counter.innerText = count
}

const saveScrollPosition = () => {
	const container = document.querySelector("[data-container]")
	const y = container.scrollTop.toString()

	sessionStorage.setItem("scrollPosition_", y)
}

const restoreScrollPosition = height => {
	const container = document.querySelector("[data-container]")
	const msg = document.querySelector(".cart_drawer--messege")
	const y = height
		? Number(sessionStorage.getItem("scrollPosition_")) + height
		: Number(sessionStorage.getItem("scrollPosition_"))

	container.scrollTo(0, msg.classList.contains("hidden") ? y : y - msg.clientHeight)
}

const getCart = async () => {
	const url = "https://api.myshopapps.com/cart/V1/fetchCart/"
	const options = {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		}
	}
	const data = await fetch("/cart.json")
	const json = await data.json()
	return json
}

const reloadCart = data => {
	const reload = document.getElementById("cart_drawer_reload")
	const newSection = data.sections.cart_drawer
	const parsed = new DOMParser().parseFromString(newSection, "text/html")
	const newReload = parsed.getElementById("cart_drawer_reload")

	reload.innerHTML = newReload.innerHTML
}

const update = async (url, minusHeight) => {
	const cart = await fetchData(url)
	reloadCart(cart)
	checkIfCartIsEmpty(cart.item_count)

	if (cart.item_count) {
		updateCounter(cart.item_count)
	} else {
		const q = document.querySelectorAll(".cart_drawer--item__quantity-value")
		let qa = 0
		q.forEach(el => {
			qa = qa + Number(el.textContent)
		})
		updateCounter(qa)
	}

	// saveScrollPosition()
	await renderUpsell()

	setTimeout(async () => {
		currentTotalPrice = cart.total_price / 100
		updateShipping(cart.total_price)
		await getWishlist()
		checkIfCartIsEmpty(cart.item_count)
	}, 10)
}

const fetchData = async url => {
	const data = await fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		}
	})
	const json = await data.json()
	showErrorMessege(json.message)

	return json
}

const addItem = async (id, flag, quantity = 1) =>
	await update(`/cart/add.js?id=${id}&quantity=${quantity}&sections=cart_drawer`, flag, quantity)
const removeItem = async (id, flag, quantity = 0) =>
	await update(`/cart/change.js?id=${id}&quantity=${quantity}&sections=cart_drawer`, flag, quantity)
const decreaseQuantity = async (id, quantity) =>
	await update(`/cart/change.js?id=${id}&quantity=${Number(quantity) - 1}&sections=cart_drawer`)
const increaseQuantity = async (id, quantity) =>
	await update(`/cart/change.js?id=${id}&quantity=${Number(quantity) + 1}&sections=cart_drawer`)

const closeCart = () => {
	const atcDrawer = document.querySelector("#prdsctcst")
	if (atcDrawer) atcDrawer.classList.remove("show")
	document.documentElement.classList.remove("cart_fade_in")

	setTimeout(() => {
		document.documentElement.classList.remove("cart_change_index")
	}, 400)
}

const openCart = e => {
	if (e) stopEvents(e)
	document.documentElement.classList.add("cart_block")
	setTimeout(() => {
		document.documentElement.classList.add("cart_change_index")
		document.documentElement.classList.add("cart_fade_in")
	}, 10)
	updateShipping(currentTotalPrice)
}

const showErrorMessege = text => {
	// const messege = document.querySelector('.cart_drawer--messege--error')
	// if (messege) {
	//   const textEl = messege.querySelector('[cart-banner-text]')
	//   textEl.innerHTML = text
	//   messege.classList.remove('hidden')
	// }
}

const showMessege = text => {
	const messege = document.querySelector(".cart_drawer--messege")
	if (messege) {
		const textEl = messege.querySelector("[cart-banner-text]")
		textEl.innerHTML = text
		messege.classList.remove("hidden")
	}
}

const hideMessege = () => {
	const messege = document.querySelector(".cart_drawer--messege")
	if (messege) {
		const textEl = messege.querySelector("[cart-banner-text]")
		textEl.innerHTML = ""
		messege.classList.add("hidden")
	}
}
const fadeOut = el => {
	return new Promise(resolve => {
		el.style.transition = "opacity 0.4s"
		el.style.opacity = 0
		setTimeout(() => {
			resolve()
		}, 400)
	})
}

const initRemoveFromWishlist = () => {
	document.querySelectorAll(".cart_upsell-remove-from-wishlist").forEach(el => {
		el.addEventListener("click", async e => {
			stopEvents(e)
			const id = el.getAttribute("data-id")
			const variantId = el.getAttribute("data-variant-id")
			const customerId = el.getAttribute("data-customer-id")
			el.closest(".cart_upsell-product").style.opacity = 0.5
			await removeItemFromWishlist(id, variantId, customerId)
		})
	})
}

const addEventWishlistBtn = () => {
	document.querySelectorAll('[data-id="#nt_wishlist"]').forEach(el => {
		el.addEventListener("click", async e => {
			stopEvents(e)
			openCart()
			if (window.customerId === "") {
				showWishlistPopup()
			}
		})
	})
	document.querySelectorAll(".iWishView.mst-wishlist-desktop").forEach(el => {
		el.addEventListener("click", async e => {
			stopEvents(e)
			openWishlistDrawer(e)
		})
	})
}

const checkWishlistItems = async items => {
	items.forEach(item => {
		if (document.querySelector('.wishlist_btn_product_card[data-id="' + item.id + '"]')) {
			document
				.querySelectorAll('.wishlist_btn_product_card[data-id="' + item.id + '"]')
				.forEach(el => {
					el.classList.add("added")
				})
		}
	})
}
const pages = {
	upsell: 0,
	wishlist: 0
}
renderUpsell()

const fixLoadmore = e => {
	if (document.querySelector("[data-upsell-grid] .cart_upsell-product").length < 5) {
		document.querySelector("[data-upsell-grid] .cart_upsell-product").forEach((el, i) => {
			console.log(i, upsellPage * 4)

			if (i < 4 * upsellPage) {
				el.classList.add("hidden")
			} else {
				el.classList.remove("hidden")
			}
		})
	}
	if (e.target.getAttribute("data-tab-loadmore") === "upsell") {
		upsellPage = upsellPage + 1
	}
}

// Ensure a given element only gets one listener, even if init() runs again
function onOnce(el, type, handler) {
  const key = '__bound_' + type;
  if (el[key]) return;
  el[key] = true;
  el.addEventListener(type, handler);
}

const init = () => {
	const btns = {
		remove: document.querySelectorAll("[data-cart-remove]"),
		quantity: {
			minus: document.querySelectorAll("[data-cart-minus]"),
			plus: document.querySelectorAll("[data-cart-plus]")
		},
		sizes: document.querySelectorAll(".cart_upsell-variants__size"),
		swatches: document.querySelectorAll(".cart_upsell-product .cart_upsell-variants__color"),
		close_cart: document.querySelector(".cart_x"),
		open_cart: document.querySelectorAll('[href="/cart"]:not(.cart-btn)'),
		loadmore: document.querySelectorAll("[data-loadmore]"),
		tabControls: document.querySelectorAll("[data-tab-control]"),
		atc: document.querySelectorAll(".single_add_to_cart_button"),
		change: document.querySelectorAll("[data-change-product]")
	}

	btns.remove.forEach(btn => {
		onOnce(btn,"click", async () => {
			const id = btn.getAttribute("data-cart-remove")
			await fadeOut(btn.closest(".cart_drawer--item"))

			if (btn.closest(".cart_drawer--item")) {
				btn.closest(".cart_drawer--item").remove()
				if (btn.getAttribute("data-cart-items") === "1") {
					const bar = document.querySelector(".cart-shipping_bar")
					if (bar) bar.classList.add("hidden")
					const total = document.querySelector("[data-cart-total]").classList.add("hidden")
					if (total) total.classList.add("hidden")
					const items = document.querySelector(".cart_drawer--items")
					if (items) items.classList.add("hidden")
					const empty = document.querySelector("[data-cart-empty]")
					if (empty) empty.classList.remove("hidden")
				}
			}

			const title = btn.getAttribute("data-title")
			if (title) showMessege(window.cartDrawer.removeFromCart.replace("{{title}}", title))
			await removeItem(id, true)
			if (title) showMessege(window.cartDrawer.removeFromCart.replace("{{title}}", title))
			const productId = btn.getAttribute("data-cart-remove-product")
			const quantity = btn.getAttribute("data-cart-remove-quantity")
			document.querySelector(".cart_drawer--messege__undo").setAttribute("data-action", "add")
			if (productId)
				document.querySelector(".cart_drawer--messege__undo").setAttribute("data-id", productId)
			if (quantity)
				document
					.querySelector(".cart_drawer--messege__undo")
					.setAttribute("data-quantity", quantity)
		})
	})

	btns.quantity.minus.forEach(btn => {
		onOnce(btn,"click", async () => {
			const id = btn.getAttribute("data-cart-minus")
			const q = btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText
			btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText =
				Number(q) - 1
			if (btn.closest(".cart_drawer--item__quantity")) {
				btn
					.closest(".cart_drawer--item__quantity")
					.classList.add("cart_drawer--item__quantity--changing")
			}
			if (Number(q) === 1) {
				fadeOut(btn.closest(".cart_drawer--item"))
			}
			decreaseQuantity(id, q)
		})
	})
	const undo = document.querySelector(".cart_drawer--messege__undo")
	if (undo)
		undo.addEventListener("click", async e => {
			const id = document.querySelector(".cart_drawer--messege__undo").getAttribute("data-id")
			const quantity = document
				.querySelector(".cart_drawer--messege__undo")
				.getAttribute("data-quantity")

			if (
				document.querySelector(".cart_drawer--messege__undo").getAttribute("data-action") === "add"
			) {
				await addItem(Number(id), true, quantity)
				hideMessege()
			} else {
				await removeItem(Number(id), true, quantity)
				hideMessege()
			}
		})

	btns.quantity.plus.forEach(btn => {
		onOnce(btn,"click", async () => {
			const id = btn.getAttribute("data-cart-plus")
			const q = btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText
			btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText =
				Number(q) + 1
			if (btn.closest(".cart_drawer--item__quantity")) {
				btn
					.closest(".cart_drawer--item__quantity")
					.classList.add("cart_drawer--item__quantity--changing")
			}
			increaseQuantity(id, q)
		})
	})

	btns.close_cart.addEventListener("click", closeCart)
	btns.open_cart.forEach(btn => btn.addEventListener("click", openCart))

	btns.tabControls.forEach(btn => {
		btn.addEventListener("click", () => {
			const currentTab = btn.getAttribute("data-tab-control")
			const tabs = document.querySelectorAll("[data-tab]")

			tabs.forEach(tab => {
				if (tab.getAttribute("data-tab") !== currentTab) return
				if (window.customerId === "") {
					showWishlistPopup()
					return
				}
				tabs.forEach(tab => {
					tab.classList.add("hidden")
				})
				btns.tabControls.forEach(btn => {
					btn.classList.remove("selected")
				})
				btn.classList.add("selected")
				tab.classList.remove("hidden")
			})

			setTimeout(() => {
				loadmoreCleanup()
			}, 500)
		})
	})
	const w_list = document.querySelector('[data-tab-control="wishlist"]')
	if (w_list)
		w_list.addEventListener("click", () => {
			getWishlist()
		})

	btns.loadmore.forEach(btn => {
		btn.addEventListener("click", () => {
			const currentTab = btn.getAttribute("data-tab-loadmore")
			const collections = document.querySelectorAll("[data-upsell-grid]")
			collections.forEach((collection, i) => {
				if (collection.getAttribute("data-tab") !== currentTab) return
				const prds = document.querySelectorAll(
					"[data-upsell-grid][data-tab=" + currentTab + "] .cart_upsell-product"
				).length

				// collection.classList.add('cart_upsell-grid--show').classList.add('hidden')

				// if (prds > 6 && document.querySelector('.selected[data-tab-control="w"]')) {
				btn.classList.add("hidden")
				// }
			})
			if (btn.getAttribute("data-tab-loadmore") === "upsell") {
				document
					.querySelector('[data-upsell-grid][data-tab="upsell"]')
					.classList.add("cart_upsell-grid--show")
				document.querySelector("[data-tab-loadmore=upsell]").classList.add("hidden")
			} else {
				document
					.querySelector('[data-upsell-grid][data-tab="wishlist"]')
					.classList.add("cart_upsell-grid--show")
			}
		})
	})

	document.addEventListener("click", async e => {
		if (e.target.classList.contains("prdsctcst__cont-form-btn")) {
			stopEvents(e)
			const id = e.target.closest("form").querySelector("#variant_select").selectedOptions
				? e.target.closest("form").querySelector("#variant_select").selectedOptions[0].value
				: e.target.closest("form").querySelector("#variant_select").value

			if (!id) return
			if (id === 0 || id === "0") return

			const changeId = sessionStorage.getItem("cart_change_id")
			if (changeId) {
				await removeItem(changeId)
				sessionStorage.removeItem("cart_change_id")
			}
			addItem(Number(id))
			openCart(e)
		}
	})

	document.addEventListener("click", async e => {
		if (
			e.target.classList.contains("product_popup_opener") ||
			e.target.closest(".product_popup_opener")
		) {
			stopEvents(e)
			const handle =
				e.target.getAttribute("data-handle") ||
				e.target.closest(".product_popup_opener").getAttribute("data-handle")
			if (!handle) return
			await updateCartSectionAsync(handle)
			closeCart()
			updateCartSectionOpener()
			return
		}
		if (
			e.target.classList.contains("single_add_to_cart_button") &&
			e.target.closest(".variations_form_ppr")
		) {
			if (
				e.target.closest("#cart-form_ppr") &&
				e.target
					.closest("#cart-form_ppr")
					.querySelector("#swatchListSize .swatch_pr_item.is-selected") === null
			) {
				return
			}
			const changeId = sessionStorage.getItem("cart_change_id")

			if (changeId) {
				await removeItem(changeId)
				sessionStorage.removeItem("cart_change_id")
			}
			updateQuickAddText()
			const id = e.target.closest("form").querySelector("#variant_select").value
			if (!id) return
			addItem(Number(id))
		}
	})

	btns.atc.forEach(btn => {
		btn.addEventListener("click", async e => {
			if (
				e.target.closest("#cart-form_ppr") &&
				e.target.closest("#cart-form_ppr").querySelector("#swatchListSize")
			) {
				if (
					e.target
						.closest("#cart-form_ppr")
						.querySelector("#swatchListSize .swatch_pr_item.is-selected") === null
				) {
					return
				}
				const changeId = sessionStorage.getItem("cart_change_id")
				if (changeId) {
					await removeItem(changeId)
					sessionStorage.removeItem("cart_change_id")
				}
				const id = btn.closest("form").querySelector("[data-productid]").selectedOptions
					? btn.closest("form").querySelector("[data-productid]").selectedOptions[0].value
					: btn.closest("form").querySelector("[data-productid]").value
				if (!id) return
				stopEvents(e)

				addItem(Number(id))
				openCart(e)
				const counter = document.querySelector(".icon_cart .tcount")
				if (counter) counter.innerText = Number(counter.innerText) + 1
			} else {
				const changeId = sessionStorage.getItem("cart_change_id")
				if (changeId) {
					await removeItem(changeId)
					sessionStorage.removeItem("cart_change_id")
				}
				const id = btn.closest("form").querySelector("[data-productid]").selectedOptions
					? btn.closest("form").querySelector("[data-productid]").selectedOptions[0].value
					: btn.closest("form").querySelector("[data-productid]").value
				if (!id) return
				addItem(Number(id))
				openCart(e)
			}
		})
	})

	btns.sizes.forEach(btn => {
		btn.addEventListener("click", async e => {
			const id = btn.getAttribute("data-id")
			if (!id) return
			const title = btn.getAttribute("data-title")

			if (title) showMessege(window.cartDrawer.addedToCart.replace("{{title}}", title))
			await addItem(Number(id), true)
			if (title) showMessege(window.cartDrawer.addedToCart.replace("{{title}}", title))

			let quantity = 2
			const quantityEls = document.querySelectorAll("[data-cart-remove-product]")
			quantityEls.forEach(el => {
				if (el.getAttribute("data-cart-remove-product") === id) {
					quantity = Number(el.getAttribute("data-cart-remove-quantity"))
				}
			})

			document.querySelector(".cart_drawer--messege__undo").setAttribute("data-action", "remove")
			document.querySelector(".cart_drawer--messege__undo").setAttribute("data-id", id)
			document
				.querySelector(".cart_drawer--messege__undo")
				.setAttribute("data-quantity", quantity - 1)
		})
	})

	btns.swatches.forEach(btn => {
		btn.addEventListener("click", async e => {
			if (window.innerWidth > 760) {
				const handle = btn.getAttribute("data-change-product")
				if (!handle) return
				const id = btn.getAttribute("data-change-id")
				if (id) sessionStorage.setItem("cart_change_id", id)
				window.updateCartSection(handle)
				// window.updateCartSectionOpener()
			}
		})
	})

	btns.change.forEach(btn => {
		btn.addEventListener("click", async e => {
			const handle = btn.getAttribute("data-change-product")
			if (!handle) return
			const id = btn.getAttribute("data-change-id")
			if (id) sessionStorage.setItem("cart_change_id", id)
			const fromUpsell = btn.closest(".cart_upsell-product__variants") ? true : false
			if (fromUpsell) sessionStorage.removeItem("cart_change_id")

			document.body.classList.add("popup_edit")
			await window.updateCartSectionAsync(handle)
			window.updateCartSectionOpener()
			setTimeout(() => {
				const size = btn.getAttribute("product-change-size")
				if (size) {
					const sizeEl = document.querySelectorAll(
						`#shopify-section-product_popup .prdsctcst__variant-list-item`
					)
					sizeEl.forEach(el => {
						if (el.querySelector("input").value.trim() === size.trim()) {
							el.querySelector("label").click()
						}
					})
				}
			}, 500)
		})
	})

	document.querySelectorAll(".cart_upsell-product a").forEach(el => {
		el.addEventListener("click", e => {
			if (window.innerWidth < 767) {
				stopEvents(e)
				const parent = e.target.closest(".cart_upsell-product")
				if (!parent) return
				const opener = parent.querySelector(".product_popup_opener")
				if (opener) opener.click()
				return
			}
		})
	})
	const container = document.querySelector("[data-container]")
	container.addEventListener("scroll", () => {
		sessionStorage.setItem("scrollPosition_", container.scrollTop)
	})
	updateShipping(window.cartDrawer.totalPrice)
	const reloadSection = document.querySelector("#cart_drawer_reload")
	if (reloadSection) {
		reloadSection.addEventListener("click", e => {
			if (e.target === reloadSection) {
				sessionStorage.removeItem("cart_change_id")
				document.body.classList.remove("popup_edit")
				closeCart()
			}
		})
	}
	const overl = document.querySelector(".prdsctcst__overlay")
	if (overl) {
		overl.addEventListener("click", e => {
			if (e.target === overl) {
				sessionStorage.removeItem("cart_change_id")
				document.body.classList.remove("popup_edit")
			}
		})
	}
	document.addEventListener("click", e => {
		if (e.target.className === "cart_drawer-popup") closeWishlistPupup()
	})

	document.querySelectorAll("[wishlist_btn_product_card]").forEach(el => {
		el.addEventListener("click", async e => {
			stopEvents(e)
			const id = el.getAttribute("data-id")
			const variantId = el.getAttribute("data-variant-id")
			const upsellProd = el.closest(".cart_upsell-product")
			if (upsellProd) upsellProd.style.opacity = 0.5
			if (window.customerId === "") {
				showWishlistPopup()
				return
			} else {
				if (el.classList.contains("added")) {
					await removeItemFromWishlist(id, variantId, Number(window.customerId))
					el.classList.remove("added")
				} else {
					await addItemToWishlist(id, variantId, Number(window.customerId))
					el.classList.add("added")
				}
			}
			if (upsellProd) upsellProd.style.opacity = 1
		})
	})
	addEventPdpButton()
	initNewPdpEvents()

	addEventWishlistBtn()
	getWishlistItems()

	setTimeout(() => {
		loadmoreCleanup()
	}, 50)
}


// Expose binder and normalized helpers for the add-on controller
window.bt = init; // (re)attach all cart listeners

window.CartHelpers = {
  // (variantId, flag=true, qty=1)
  add: (id, flag = true, qty = 1) => addItem(Number(id), flag, qty),
  // (variantId, qty) -> your removeItem is actually "set qty"
  change: (id, qty = 0) => removeItem(Number(id), true, Number(qty))
};

